// Slim full-width banner pinned above the global Navbar. Replaces the
// large in-feed Hackathon CTA so the home page can stay minimal: one
// line, current pot, link to /hackathon.
import { Link } from "react-router-dom";
import { Trophy, ArrowRight } from "lucide-react";
import { useHackathon, formatUsd } from "@/hooks/useHackathon";

export default function HackathonBanner() {
  const { pot } = useHackathon({ scoreboardLimit: 1 });
  const potLabel = pot ? formatUsd(pot.pot_cents) : "$10,000";

  return (
    <Link
      to="/hackathon"
      className="group block w-full border-b border-primary/30 bg-primary/10 hover:bg-primary/15 transition-colors"
    >
      <div className="container mx-auto px-4 py-1.5 flex items-center justify-center gap-2 text-[11px] sm:text-xs font-mono">
        <Trophy className="w-3.5 h-3.5 text-primary shrink-0" />
        <span className="text-foreground">
          Hackathon · pot{" "}
          <span className="text-primary font-semibold">{potLabel}</span>
        </span>
        <span className="hidden sm:inline text-muted-foreground">
          — build the most, win the pot.
        </span>
        <span className="inline-flex items-center gap-0.5 text-primary group-hover:underline underline-offset-2">
          Join <ArrowRight className="w-3 h-3" />
        </span>
      </div>
    </Link>
  );
}